import * as tslib_1 from "tslib";
import { CommandContainer } from './command_container';
var Menu = /** @class */ (function (_super) {
    tslib_1.__extends(Menu, _super);
    function Menu(param) {
        return _super.call(this, param) || this;
    }
    Menu.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "Menu" });
    };
    Menu.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Menu;
}(CommandContainer));
export { Menu };
//# sourceMappingURL=menu.js.map